// composables/useGeolocation.js
import { ref, onUnmounted } from "vue";

export function useGeolocation() {
  const currentPosition = ref(null);
  const error = ref(null);
  const isTracking = ref(false);
  let watchId = null;

  const startTracking = () => {
    if (!navigator.geolocation) {
      error.value = "Geolocation is not supported by your browser";
      return;
    }

    isTracking.value = true;

    watchId = navigator.geolocation.watchPosition(
      (position) => {
        currentPosition.value = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          heading: position.coords.heading || null,
          timestamp: new Date().toISOString(),
        };
      },
      (err) => {
        error.value = err.message;
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      },
    );
  };

  const stopTracking = () => {
    if (watchId !== null) {
      navigator.geolocation.clearWatch(watchId);
      watchId = null;
      isTracking.value = false;
    }
  };

  // Clean up the watcher if the component is unmounted
  onUnmounted(() => {
    stopTracking();
  });

  return {
    currentPosition,
    error,
    isTracking,
    startTracking,
    stopTracking,
  };
}
